// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2Zoc8","messages":"Chat_messages__2BZd4","dateDivider":"Chat_dateDivider__1mq40"};